import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
//import authStore from './stores/authStore';

const superagent = superagentPromise(_superagent, global.Promise);

const API_ROOT = getApiRoot();
const STATIC_ROOT = window.location.protocol + '//' +  window.location.hostname
const APIGEE_ROOT = getApigeeRoot();
const ENVIRONMENT = getEnvironment();

function getApiRoot() {
    var host = window.location.hostname;
    if ( host.indexOf( 'webdev' ) > -1 && window.location.protocol === 'http:' ) {
        return 'http://api.dev.24go.co';
    }
    if ( host.indexOf( 'webdev' ) > -1 || host.indexOf( 'webqa' ) > -1 ) {
        return 'https://api.staging.24go.io';
    }
    return 'https://api.24go.co';
}

function getApigeeRoot() {
    var host = window.location.hostname;
    if ( host.indexOf( 'webdev' ) > -1 ) {
        return 'https://api-dev.24hourfitness.com';
    }
    if ( host.indexOf( 'webqa' ) > -1 ) {
        return 'https://api-qa.24hourfitness.com';
    }
    if ( host.indexOf( 'webtrn' ) > -1 ) {
        return 'https://api-trn.24hourfitness.com';
    }
    return 'https://api.24hourfitness.com';
}

function getEnvironment() {
    var host = window.location.hostname;
    if ( host.indexOf( 'webdev' ) > -1 ) {
        return 'dev';
    }
    if ( host.indexOf( 'webqa' ) > -1 ) {
        return 'qa';
    }
    if ( host.indexOf( 'webtrn' ) > -1 ) {
        return 'trn';
    }
    return 'prd';
}

const handleErrors = err => {
    if (err && err.response && err.response.status === 401) {
        console.log(err.response)
        alert('Service is unavailable')
    }
    return err;
};

const responseBody = res => res.body;
const responseHTML = res => res.text;

const requests = {
    static_html: url =>
        superagent
            .get(`${API_ROOT}${url}`)
            .accept('Accept', 'text/html')
            .set('environment', ENVIRONMENT)
            .end(handleErrors)
            .then(responseHTML),
    static_asset: url =>
        superagent
            .get(`${STATIC_ROOT}${url}`)
            .withCredentials()
            .set('Accept', 'application/json')
            .set('environment', ENVIRONMENT)
            .end(handleErrors)
            .then(responseBody),
    del: url =>
        superagent
            .del(`${API_ROOT}${url}`)
            .withCredentials()
            .set('environment', ENVIRONMENT)
            .end(handleErrors)
            .then(responseBody),
    get: url =>
        superagent
            .get(`${API_ROOT}${url}`)
            .withCredentials()
            .set('environment', ENVIRONMENT)
            .set('Accept', 'application/json')
            .end(handleErrors)
            .then(responseBody),
    put: (url, body) =>
        superagent
            .put(`${API_ROOT}${url}`, body)
            .type('json')
            .withCredentials()
            .set('environment', ENVIRONMENT)
            .end(handleErrors)
            .then(responseBody),
    post: (url, body) =>
        superagent
            .post(`${API_ROOT}${url}`, body)
            .type('json')
            .withCredentials()
            .set('environment', ENVIRONMENT)
            .end(handleErrors)
            .then(responseBody),
    postForm: (url, body) =>
        superagent
            .post(`${API_ROOT}${url}`)
            .type('form')
            .send(body)
            .withCredentials()
            .set('environment', ENVIRONMENT)
            .end(handleErrors)
            .then(responseBody),
    apiGet: ( url ) =>
        _superagent
            .get( `${APIGEE_ROOT}${url}` ),
    apiGetWithToken: ( url, token ) =>
        _superagent
            .get( `${APIGEE_ROOT}${url}` )
            .set( 'securityToken', token ),
    apiPost: (url, body) =>
        _superagent
            .post( `${APIGEE_ROOT}${url}` )
            .send( body ),
    apiPostWithToken: ( url, token, body ) => 
        _superagent
                .post( `${APIGEE_ROOT}${url}` )
                .set( 'securityToken', token )
                .send( body ),
    apiPostWithCart: ( url, cartId, body ) =>
        _superagent
            .post( `${APIGEE_ROOT}${url}` )
            .set( 'Cart-Id', cartId )
            .send( body ),
    apiGetWithCart: ( url, cartId ) =>
        _superagent
            .get( `${APIGEE_ROOT}${url}` )
            .set( 'Cart-Id', cartId )
};

const DGR = {
    createPassWithGuardian: (
        email,
        first_name,
        last_name,
        birthday,
        club_number,
        phone, 
        zipcode, 
        gender,
        is_waiver_signed,
        is_sms_allowed,
        guardian_first_name ,
        guardian_last_name ,
        guardian_address ,
        guardian_zip ,
        guardian_city ,
        guardian_state ,
        guardian_phone 
    ) => 
        requests.post('/leads', {
            email,
            first_name,
            last_name,
            birthday,
            club_number,
            phone, 
            zipcode, 
            gender,
            is_waiver_signed,
            is_sms_allowed,
            guardian_first_name ,
            guardian_last_name ,
            guardian_address ,
            guardian_zip ,
            guardian_city ,
            guardian_state ,
            guardian_phone 
        }),
    createPass: (
            email, 
            first_name, 
            last_name, 
            birthday, 
            club_number, 
            phone,
            zipcode,
            gender,
            is_waiver_signed,
            is_sms_allowed
    ) => 
        requests.post('/leads', {
            email, 
            first_name, 
            last_name, 
            birthday, 
            club_number, 
            phone, 
            zipcode,
            gender,
            is_waiver_signed,
            is_sms_allowed
        }),
    getVersion: (club_number) => {
        var random = new Date().getTime();
        return requests.static_asset(`/go/dgr/version.json?ran=${random}`) 
    },
    getClubData: (club_number) =>
        requests.get(`/clubs/number/${club_number}`),
    enterPassUserCreds: (first_name, last_name, birthday, club_number) => {
        var random = new Date().getTime();
        return requests.get(`/leads?first_name=${first_name}&last_name=${last_name}&birthday=${birthday}&club_number=${club_number}&ran=${random}`)
    },
    enterPassGuestPass: (guestPass, club_number) =>
        requests.get(`/leads?pass_code=${guestPass}&club_number=${club_number}`),
    checkIn: (lead_number, club_number) =>
        requests.post('/leads/visits', {lead_number, club_number}),
    externalHTMLProductPages: ( club_number, club_product_id ) =>
        requests.static_html(`/dgr/details/${club_number}/${club_product_id}`),
    externalHTMLWaiverPage: ( state  ) =>
        requests.static_html(`/dgr/waiver/${state}`),
    getStoreData: (club_number) =>
        requests.get(`/sales_channel/prices/${club_number}`),
    authLogin: ( username, password, securityToken ) => {
        if ( securityToken ) {
            return requests.apiPostWithToken( '/account/users/login', securityToken, { username, password })
        } else {
            return requests.apiPost( '/account/users/login', { username, password })
        }
    },
    authUserInfo: ( username, securityToken ) => {
        var random = new Date().getTime();
        return requests.apiGetWithToken( `/account/users/${username}?ran=${random}`, securityToken )
    },
    authForgot: ( email, forgot_field ) =>
        requests.apiPost( `/account/auth/${forgot_field}`, { email } ),
    authValidate: ( memberIdentifier, birthday ) =>
        requests.apiPost( '/account/members/validate', { memberIdentifier, birthday } ),
    authValidateEmail: ( email, securityToken ) =>
        requests.apiPostWithToken( '/account/users/validate-email', securityToken, { email } ),
    authValidateUsername: ( username, securityToken ) =>
        requests.apiPostWithToken( '/account/users/validate-username', securityToken, { username } ),
    authCreate: ( userObject, securityToken ) =>
        requests.apiPostWithToken( '/account/users', securityToken, userObject ),
    authUnsignedAgreements: ( member_number ) => {
        var random = new Date().getTime();
        return requests.apiGet( `/sales/accounts/${member_number}/signatures?ran=${random}` )
    },
    salesCreateCart: () =>
        requests.apiPost( '/sales/orders', {} ),
    salesCreateCustomer: ( cartId ) =>
        requests.apiPostWithCart( '/sales/orders/customers', cartId, { "customerTypeId": "primary" } ),
    salesCheckCostcoCode: ( cartId, customerId, promoCode ) =>
        requests.apiPostWithCart( '/sales/orders/promo', cartId, { "customerId": customerId, "type": "costco", "promoCode": promoCode }),
    salesGetCart: ( cartId, customerId ) => {
        var random = new Date().getTime();
        return requests.apiGetWithCart( `/sales/orders/products?productType=Membership&customerId=${ customerId }&ran=${ random }`, cartId )
    },
    trackSelection: ( lead_number, selection ) =>
        requests.get(`/leads/track_selection?lead_number=${lead_number}&selection=${selection}`)

}

export default {
  DGR
};



// WEBPACK FOOTER //
// ./src/api/agent.js